import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, IconButton, Grid, } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ButtonContained from '../../../Common/ButtonContained';
import ButtonOutlined from '../../../Common/ButtonOutlined';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useDispatch } from 'react-redux';
import { addStage, deleteStage, getStage, updateStage } from '../../../../Redux/Actions/action';
import { toast } from 'react-toastify';
import ErrorHandler from '../../../../Utils/handler';
import CustomDialog from '../../../Common/CustomDialog';
import CommonTextField from '../../../Common/CommonTextField';
import { useConfirm } from 'material-ui-confirm';
import TextLabel from '../../../Common/CommonTextLabel';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { showLoader } from '../../../../Redux/Slices/loaderSlice';


const StageOfClaims = () => {
    // ---------- Hook -----------
    const dispatch = useDispatch();
    const confirmDialogue = useConfirm();

    // --------------- State -------------
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({})
    const [stages, setStages] = useState([]);
    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    // --------------- handleChange ---------------
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({})
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const validation = () => {
        let isValid = true;
        let error = {}
        if (!data.stageName) {
            error.stageName = "* Stage name is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    }

    // --------------- Api ---------------
    const _createUpdateStage = async () => {
        if (validation()) {
            dispatch(showLoader(true))
            try {
                let body = {
                    stageName: data?.stageName,
                }
                if (isEdit && data?._id) {
                    body.id = data?._id;
                    body.sequence = data?.sequence;
                }
                const fn = isEdit ? updateStage : addStage
                const result = await dispatch(fn(body))
                const error = ErrorHandler(result)
                if (error) {
                    toast.success(result?.payload?.message);
                    _getStage()
                    handleClear()
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false))
            }
        }
    }

    const _getStage = async () => {
        dispatch(showLoader(true))
        try {
            const result = await dispatch(getStage());
            const error = ErrorHandler(result);
            if (error) {
                console.log(result, "result")
                // toast.success(result?.payload?.message);
                setStages(result?.payload?.data?.stages);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    const _deleteStage = async (id) => {
        try {
            const result = await dispatch(deleteStage(`/${id}`));
            console.log(result, 'deletefaq')
            const error = ErrorHandler(result);
            if (error) {
                toast.success(result?.payload?.message);
                _getStage()
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const handleDragEnd = async (result) => {
        const { destination, source } = result;
        if (!destination) return;

        const reorderedStages = Array.from(stages);
        const [movedStage] = reorderedStages.splice(source.index, 1);
        reorderedStages.splice(destination.index, 0, movedStage);

        if (source.index !== destination.index) {

            try {
                const body = {
                    _id: movedStage._id,    // ID of the moved stage
                    stageName: movedStage?.stageName,
                    sequence: destination.index + 1, // New sequence (1-based index)
                };
                const result = await dispatch(updateStage(body))
                const error = ErrorHandler(result)
                if (error) {
                    toast.success(result?.payload?.message);
                    _getStage()
                    handleClear()
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            }
        };
    }

    // ---------- useEffect ------------ 
    useEffect(() => {
        _getStage()
    }, [])

    return (
        <>
            <Grid container sx={{ backgroundColor: '#f8f8f8', padding: '18px', borderRadius: '8px' }} spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>Stage of Claims</Typography>
                        <ButtonContained text="Add New Stage" onClick={() => setOpen(true)} />
                    </Box>
                </Grid>
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="stagesList">
                        {(provided) => (
                            <Grid container spacing={1} item xs={12} ref={provided.innerRef} {...provided.droppableProps}>
                                {stages.map((stage, index) => (
                                    <Draggable key={stage._id} draggableId={stage._id} index={index}>
                                        {(provided) => (
                                            <Grid item display={'flex'} xs={12} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                <IconButton sx={{ padding: "13px" }} >
                                                    <DragIndicatorOutlinedIcon fontSize='large' />
                                                </IconButton>
                                                <Paper
                                                    sx={{
                                                        padding: '10px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        borderRadius: '8px',
                                                        boxShadow: '4px 4px 10px 0 rgba(0, 0, 0, 0.1)',
                                                        border: '1px solid #d3d1d1',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Box>
                                                        <Typography sx={{ fontWeight: 500, fontSize: '16px' }}>{stage.stageName}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', gap: '8px' }}>
                                                        <ButtonOutlined fontSize="15px" height="40px" startIcon={<EditIcon />} text="Edit" color="success" onClick={() => {
                                                            setOpen(true);
                                                            setIsEdit(true);
                                                            setData(stage);
                                                        }} />
                                                        <ButtonOutlined fontSize="15px" color="#d32f2f" height="40px" startIcon={<DeleteForeverOutlinedIcon color='error' />} text="Delete"
                                                            onClick={() =>
                                                                confirmDialogue({ title: `Are you sure you want to delete this stage?`, })
                                                                    .then(() => {
                                                                        _deleteStage(stage?._id);
                                                                    })
                                                                    .catch((err) => { toast.error(err.message); })} />
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </Grid>
                        )}
                    </Droppable>
                </DragDropContext>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', gap: '12px', marginTop: '34px' }}>
                        <ButtonOutlined text="Cancel" />
                        <ButtonContained text="Confirm" />
                    </Box>
                </Grid>
                {open && <CustomDialog
                    isOpen={open} handleClose={handleClear} title={isEdit ? 'Update Stage' : 'Add Stage'}
                    width={400}
                    action={
                        <>
                            <ButtonContained
                                text={isEdit ? 'Update Stage' : 'Add Stage'}
                                onClick={_createUpdateStage}
                                minWidth={'100%'}
                                marginTop={'10px'}
                            />
                        </>
                    }
                >
                    <Grid container xs={12}>
                        <Grid item xs={12}>
                            <CommonTextField
                                value={data?.stageName}
                                // width={"100%"}
                                text="Stage Name"
                                type="text"
                                onChange={(e) => handleInputChange(e)}
                                placeholder="Enter Stage Name"
                                name="stageName"
                                valid
                            />
                            <TextLabel color='error' title={!data?.stageName ? error.stageName : ""} />
                        </Grid>
                    </Grid>
                </CustomDialog>}

            </Grid>
        </>
    );
};

export default StageOfClaims;
